
// @ts-nocheck
import locale__app_apps_main_i18n_locales_ru_auth_js from "../i18n/locales/ru/auth.js";
import locale__app_apps_main_i18n_locales_ru_cabinet_js from "../i18n/locales/ru/cabinet.js";
import locale__app_apps_main_i18n_locales_ru_common_js from "../i18n/locales/ru/common.js";
import locale__app_apps_main_i18n_locales_ru_entities_js from "../i18n/locales/ru/entities.js";
import locale__app_apps_main_i18n_locales_ru_footer_js from "../i18n/locales/ru/footer.js";
import locale__app_apps_main_i18n_locales_ru_header_js from "../i18n/locales/ru/header.js";
import locale__app_apps_main_i18n_locales_ru_notifications_js from "../i18n/locales/ru/notifications.js";
import locale__app_apps_main_i18n_locales_ru_pages_js from "../i18n/locales/ru/pages.js";
import locale__app_apps_main_i18n_locales_ru_profileDeleteModal_js from "../i18n/locales/ru/profileDeleteModal.js";
import locale__app_apps_main_i18n_locales_ru_projectCreateModal_js from "../i18n/locales/ru/projectCreateModal.js";
import locale__app_apps_main_i18n_locales_ru_rates_js from "../i18n/locales/ru/rates.js";
import locale__app_apps_main_i18n_locales_ru_validation_js from "../i18n/locales/ru/validation.js";
import locale__app_apps_main_i18n_locales_en_auth_js from "../i18n/locales/en/auth.js";
import locale__app_apps_main_i18n_locales_en_cabinet_js from "../i18n/locales/en/cabinet.js";
import locale__app_apps_main_i18n_locales_en_common_js from "../i18n/locales/en/common.js";
import locale__app_apps_main_i18n_locales_en_entities_js from "../i18n/locales/en/entities.js";
import locale__app_apps_main_i18n_locales_en_footer_js from "../i18n/locales/en/footer.js";
import locale__app_apps_main_i18n_locales_en_header_js from "../i18n/locales/en/header.js";
import locale__app_apps_main_i18n_locales_en_notifications_js from "../i18n/locales/en/notifications.js";
import locale__app_apps_main_i18n_locales_en_pages_js from "../i18n/locales/en/pages.js";
import locale__app_apps_main_i18n_locales_en_profileDeleteModal_js from "../i18n/locales/en/profileDeleteModal.js";
import locale__app_apps_main_i18n_locales_en_projectCreateModal_js from "../i18n/locales/en/projectCreateModal.js";
import locale__app_apps_main_i18n_locales_en_rates_js from "../i18n/locales/en/rates.js";
import locale__app_apps_main_i18n_locales_en_validation_js from "../i18n/locales/en/validation.js";
import locale__app_apps_main_i18n_locales_ka_auth_js from "../i18n/locales/ka/auth.js";
import locale__app_apps_main_i18n_locales_ka_cabinet_js from "../i18n/locales/ka/cabinet.js";
import locale__app_apps_main_i18n_locales_ka_common_js from "../i18n/locales/ka/common.js";
import locale__app_apps_main_i18n_locales_ka_entities_js from "../i18n/locales/ka/entities.js";
import locale__app_apps_main_i18n_locales_ka_footer_js from "../i18n/locales/ka/footer.js";
import locale__app_apps_main_i18n_locales_ka_header_js from "../i18n/locales/ka/header.js";
import locale__app_apps_main_i18n_locales_ka_notifications_js from "../i18n/locales/ka/notifications.js";
import locale__app_apps_main_i18n_locales_ka_pages_js from "../i18n/locales/ka/pages.js";
import locale__app_apps_main_i18n_locales_ka_profileDeleteModal_js from "../i18n/locales/ka/profileDeleteModal.js";
import locale__app_apps_main_i18n_locales_ka_projectCreateModal_js from "../i18n/locales/ka/projectCreateModal.js";
import locale__app_apps_main_i18n_locales_ka_rates_js from "../i18n/locales/ka/rates.js";
import locale__app_apps_main_i18n_locales_ka_validation_js from "../i18n/locales/ka/validation.js";
import locale__app_apps_main_i18n_locales_uz_auth_js from "../i18n/locales/uz/auth.js";
import locale__app_apps_main_i18n_locales_uz_cabinet_js from "../i18n/locales/uz/cabinet.js";
import locale__app_apps_main_i18n_locales_uz_common_js from "../i18n/locales/uz/common.js";
import locale__app_apps_main_i18n_locales_uz_entities_js from "../i18n/locales/uz/entities.js";
import locale__app_apps_main_i18n_locales_uz_footer_js from "../i18n/locales/uz/footer.js";
import locale__app_apps_main_i18n_locales_uz_header_js from "../i18n/locales/uz/header.js";
import locale__app_apps_main_i18n_locales_uz_notifications_js from "../i18n/locales/uz/notifications.js";
import locale__app_apps_main_i18n_locales_uz_pages_js from "../i18n/locales/uz/pages.js";
import locale__app_apps_main_i18n_locales_uz_profileDeleteModal_js from "../i18n/locales/uz/profileDeleteModal.js";
import locale__app_apps_main_i18n_locales_uz_projectCreateModal_js from "../i18n/locales/uz/projectCreateModal.js";
import locale__app_apps_main_i18n_locales_uz_rates_js from "../i18n/locales/uz/rates.js";
import locale__app_apps_main_i18n_locales_uz_validation_js from "../i18n/locales/uz/validation.js";


export const localeCodes =  [
  "ru",
  "en",
  "ka",
  "uz"
]

export const localeLoaders = {
  "ru": [{ key: "../i18n/locales/ru/auth.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_auth_js), cache: true },
{ key: "../i18n/locales/ru/cabinet.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_cabinet_js), cache: true },
{ key: "../i18n/locales/ru/common.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_common_js), cache: true },
{ key: "../i18n/locales/ru/entities.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_entities_js), cache: true },
{ key: "../i18n/locales/ru/footer.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_footer_js), cache: true },
{ key: "../i18n/locales/ru/header.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_header_js), cache: true },
{ key: "../i18n/locales/ru/notifications.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_notifications_js), cache: true },
{ key: "../i18n/locales/ru/pages.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_pages_js), cache: true },
{ key: "../i18n/locales/ru/profileDeleteModal.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_profileDeleteModal_js), cache: true },
{ key: "../i18n/locales/ru/projectCreateModal.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_projectCreateModal_js), cache: true },
{ key: "../i18n/locales/ru/rates.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_rates_js), cache: true },
{ key: "../i18n/locales/ru/validation.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ru_validation_js), cache: true }],
  "en": [{ key: "../i18n/locales/en/auth.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_auth_js), cache: true },
{ key: "../i18n/locales/en/cabinet.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_cabinet_js), cache: true },
{ key: "../i18n/locales/en/common.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_common_js), cache: true },
{ key: "../i18n/locales/en/entities.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_entities_js), cache: true },
{ key: "../i18n/locales/en/footer.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_footer_js), cache: true },
{ key: "../i18n/locales/en/header.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_header_js), cache: true },
{ key: "../i18n/locales/en/notifications.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_notifications_js), cache: true },
{ key: "../i18n/locales/en/pages.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_pages_js), cache: true },
{ key: "../i18n/locales/en/profileDeleteModal.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_profileDeleteModal_js), cache: true },
{ key: "../i18n/locales/en/projectCreateModal.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_projectCreateModal_js), cache: true },
{ key: "../i18n/locales/en/rates.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_rates_js), cache: true },
{ key: "../i18n/locales/en/validation.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_en_validation_js), cache: true }],
  "ka": [{ key: "../i18n/locales/ka/auth.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_auth_js), cache: true },
{ key: "../i18n/locales/ka/cabinet.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_cabinet_js), cache: true },
{ key: "../i18n/locales/ka/common.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_common_js), cache: true },
{ key: "../i18n/locales/ka/entities.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_entities_js), cache: true },
{ key: "../i18n/locales/ka/footer.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_footer_js), cache: true },
{ key: "../i18n/locales/ka/header.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_header_js), cache: true },
{ key: "../i18n/locales/ka/notifications.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_notifications_js), cache: true },
{ key: "../i18n/locales/ka/pages.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_pages_js), cache: true },
{ key: "../i18n/locales/ka/profileDeleteModal.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_profileDeleteModal_js), cache: true },
{ key: "../i18n/locales/ka/projectCreateModal.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_projectCreateModal_js), cache: true },
{ key: "../i18n/locales/ka/rates.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_rates_js), cache: true },
{ key: "../i18n/locales/ka/validation.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_ka_validation_js), cache: true }],
  "uz": [{ key: "../i18n/locales/uz/auth.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_auth_js), cache: true },
{ key: "../i18n/locales/uz/cabinet.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_cabinet_js), cache: true },
{ key: "../i18n/locales/uz/common.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_common_js), cache: true },
{ key: "../i18n/locales/uz/entities.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_entities_js), cache: true },
{ key: "../i18n/locales/uz/footer.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_footer_js), cache: true },
{ key: "../i18n/locales/uz/header.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_header_js), cache: true },
{ key: "../i18n/locales/uz/notifications.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_notifications_js), cache: true },
{ key: "../i18n/locales/uz/pages.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_pages_js), cache: true },
{ key: "../i18n/locales/uz/profileDeleteModal.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_profileDeleteModal_js), cache: true },
{ key: "../i18n/locales/uz/projectCreateModal.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_projectCreateModal_js), cache: true },
{ key: "../i18n/locales/uz/rates.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_rates_js), cache: true },
{ key: "../i18n/locales/uz/validation.js", load: () => Promise.resolve(locale__app_apps_main_i18n_locales_uz_validation_js), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n/i18n.config.ts?hash=5b32d2e0&config=1" /* webpackChunkName: "__i18n_i18n_config_ts_5b32d2e0" */)
]

export const nuxtI18nOptions = {
  "restructureDir": "i18n",
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "typedPages": true,
    "typedOptionsAndMessages": false,
    "generatedLocaleFilePathFormat": "absolute",
    "alternateLinkCanonicalQueries": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "optimizeTranslationDirective": true
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n/i18n.config.ts",
  "locales": [
    {
      "code": "ru",
      "name": "Русский",
      "files": [
        "/app/apps/main/i18n/locales/ru/auth.js",
        "/app/apps/main/i18n/locales/ru/cabinet.js",
        "/app/apps/main/i18n/locales/ru/common.js",
        "/app/apps/main/i18n/locales/ru/entities.js",
        "/app/apps/main/i18n/locales/ru/footer.js",
        "/app/apps/main/i18n/locales/ru/header.js",
        "/app/apps/main/i18n/locales/ru/notifications.js",
        "/app/apps/main/i18n/locales/ru/pages.js",
        "/app/apps/main/i18n/locales/ru/profileDeleteModal.js",
        "/app/apps/main/i18n/locales/ru/projectCreateModal.js",
        "/app/apps/main/i18n/locales/ru/rates.js",
        "/app/apps/main/i18n/locales/ru/validation.js"
      ]
    },
    {
      "code": "en",
      "name": "English",
      "files": [
        "/app/apps/main/i18n/locales/en/auth.js",
        "/app/apps/main/i18n/locales/en/cabinet.js",
        "/app/apps/main/i18n/locales/en/common.js",
        "/app/apps/main/i18n/locales/en/entities.js",
        "/app/apps/main/i18n/locales/en/footer.js",
        "/app/apps/main/i18n/locales/en/header.js",
        "/app/apps/main/i18n/locales/en/notifications.js",
        "/app/apps/main/i18n/locales/en/pages.js",
        "/app/apps/main/i18n/locales/en/profileDeleteModal.js",
        "/app/apps/main/i18n/locales/en/projectCreateModal.js",
        "/app/apps/main/i18n/locales/en/rates.js",
        "/app/apps/main/i18n/locales/en/validation.js"
      ]
    },
    {
      "code": "ka",
      "name": "ქართული",
      "files": [
        "/app/apps/main/i18n/locales/ka/auth.js",
        "/app/apps/main/i18n/locales/ka/cabinet.js",
        "/app/apps/main/i18n/locales/ka/common.js",
        "/app/apps/main/i18n/locales/ka/entities.js",
        "/app/apps/main/i18n/locales/ka/footer.js",
        "/app/apps/main/i18n/locales/ka/header.js",
        "/app/apps/main/i18n/locales/ka/notifications.js",
        "/app/apps/main/i18n/locales/ka/pages.js",
        "/app/apps/main/i18n/locales/ka/profileDeleteModal.js",
        "/app/apps/main/i18n/locales/ka/projectCreateModal.js",
        "/app/apps/main/i18n/locales/ka/rates.js",
        "/app/apps/main/i18n/locales/ka/validation.js"
      ]
    },
    {
      "code": "uz",
      "name": "O'zbekcha",
      "files": [
        "/app/apps/main/i18n/locales/uz/auth.js",
        "/app/apps/main/i18n/locales/uz/cabinet.js",
        "/app/apps/main/i18n/locales/uz/common.js",
        "/app/apps/main/i18n/locales/uz/entities.js",
        "/app/apps/main/i18n/locales/uz/footer.js",
        "/app/apps/main/i18n/locales/uz/header.js",
        "/app/apps/main/i18n/locales/uz/notifications.js",
        "/app/apps/main/i18n/locales/uz/pages.js",
        "/app/apps/main/i18n/locales/uz/profileDeleteModal.js",
        "/app/apps/main/i18n/locales/uz/projectCreateModal.js",
        "/app/apps/main/i18n/locales/uz/rates.js",
        "/app/apps/main/i18n/locales/uz/validation.js"
      ]
    }
  ],
  "defaultLocale": "ru",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": ".mydonut.app",
    "cookieKey": "donut-locale",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ru",
    "name": "Русский",
    "files": [
      {
        "path": "/app/apps/main/i18n/locales/ru/auth.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/cabinet.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/common.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/entities.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/footer.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/header.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/notifications.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/pages.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/profileDeleteModal.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/projectCreateModal.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/rates.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ru/validation.js"
      }
    ]
  },
  {
    "code": "en",
    "name": "English",
    "files": [
      {
        "path": "/app/apps/main/i18n/locales/en/auth.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/cabinet.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/common.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/entities.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/footer.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/header.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/notifications.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/pages.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/profileDeleteModal.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/projectCreateModal.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/rates.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/en/validation.js"
      }
    ]
  },
  {
    "code": "ka",
    "name": "ქართული",
    "files": [
      {
        "path": "/app/apps/main/i18n/locales/ka/auth.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/cabinet.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/common.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/entities.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/footer.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/header.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/notifications.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/pages.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/profileDeleteModal.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/projectCreateModal.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/rates.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/ka/validation.js"
      }
    ]
  },
  {
    "code": "uz",
    "name": "O'zbekcha",
    "files": [
      {
        "path": "/app/apps/main/i18n/locales/uz/auth.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/cabinet.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/common.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/entities.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/footer.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/header.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/notifications.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/pages.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/profileDeleteModal.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/projectCreateModal.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/rates.js"
      },
      {
        "path": "/app/apps/main/i18n/locales/uz/validation.js"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
